module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/icon-1eac72f84caeb9b040cb5c3667780527.jpg";